module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "page-lock"
  }, [_c('div', {
    staticClass: "page-logo"
  }, [_c('router-link', {
    staticClass: "brand",
    attrs: {
      "to": "/login"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/pages/img/logo.png",
      "alt": "logo"
    }
  })])], 1), _vm._v(" "), (_vm.validMessage != '') ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.validMessage) + " ")])]) : _vm._e(), _vm._v(" "), (!_vm.validToken) ? _c('div', {
    staticClass: "page-body"
  }, [(this.$route.name === 'Remind Token') ? _c('div', {
    staticClass: "lock-head"
  }, [_vm._v(" Reset Password")]) : _c('div', {
    staticClass: "lock-head"
  }, [_vm._v(" Confirmation Account")]), _vm._v(" "), _c('div', {
    staticClass: "lock-body"
  }, [_c('div', {
    staticClass: "lock-cont"
  }, [_c('div', {
    staticClass: "lock-item lock-item-full"
  }, [_c('form', {
    staticClass: "lock-form pull-left",
    attrs: {
      "data-vv-scope": "remind-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('remind-form.Token')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.token),
      expression: "token"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control placeholder-no-fix",
    attrs: {
      "type": "hidden",
      "autocomplete": "off",
      "placeholder": "Token",
      "name": "Token"
    },
    domProps: {
      "value": (_vm.token)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.token = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('remind-form.Token')),
      expression: "errors.has('remind-form.Token')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('remind-form.Token')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('remind-form.New Password')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        min: 6,
        max: 16,
        password: true
      }),
      expression: "{required:true, min:6, max:16, password: true}"
    }],
    staticClass: "form-control placeholder-no-fix",
    attrs: {
      "type": "password",
      "autocomplete": "off",
      "placeholder": "New Password",
      "name": "New Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('remind-form.New Password')),
      expression: "errors.has('remind-form.New Password')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('remind-form.New Password')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('remind-form.Confirm New Password')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password2),
      expression: "password2"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        is: _vm.password
      }),
      expression: "{required: true, is: password}"
    }],
    ref: "New Password",
    staticClass: "form-control placeholder-no-fix",
    attrs: {
      "type": "password",
      "autocomplete": "off",
      "placeholder": "Confirm New Password",
      "name": "Confirm New Password"
    },
    domProps: {
      "value": (_vm.password2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password2 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('remind-form.Confirm New Password')),
      expression: "errors.has('remind-form.Confirm New Password')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('remind-form.Confirm New Password')))])]), _vm._v(" "), _vm._m(0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "lock-bottom"
  }, [(this.$route.name !== 'Remind Token') ? _c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Already activated?")]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "page-footer-custom"
  }, [_vm._v("© " + _vm._s(new Date().getFullYear()) + " CaseMGR Solutions, Inc. All Rights Reserved.")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-actions"
  }, [_c('button', {
    staticClass: "btn btn-warning mt-ladda-btn ladda-button check-token",
    attrs: {
      "type": "submit",
      "data-style": "expand-left"
    }
  }, [_c('span', {
    staticClass: "ladda-label"
  }, [_vm._v("Submit")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63dfb7cc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Confirmation.vue
// module id = 1669
// module chunks = 1